import Router from './routes';
import './App.css';
import ReactFullscreen from 'react-easyfullscreen';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { screenStatus } from './redux/features/settingsSlice';
import { transitionStatus, sideBarSettings } from './redux/features/settingsSlice';
// import useSocketNotifications from "./Hooks/useSocketNotifications";
// import NotificationSnackbar from "./components/snackbar/NotificationSnackbar";
import { SnackbarProvider, useSnackbar } from 'notistack';
import { setSnackbar } from './api/request';

function App() {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.settings);

  // useSocketNotifications();

  useEffect(() => {
    dispatch(
      sideBarSettings({
        bgColor: 'default',
        color: '',
      })
    );
    dispatch(screenStatus('NotActive'));
    dispatch(
      transitionStatus({
        transition: 'Fade',
        otherProps: '',
      })
    );
  }, []);
  const SnackbarInitializer = ({ children }) => {
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
      setSnackbar(enqueueSnackbar);
    }, [enqueueSnackbar]);
    return children;
  };

  return (
    // <ReactFullscreen>
    //     {({ ref, onRequest, onExit }) => (
    <>
      {/* {status.screenStatus === "Active" ? onRequest() : onExit()} */}
      <SnackbarProvider maxSnack={3}>
        <SnackbarInitializer>
            <Router />
          {/* <NotificationSnackbar /> */}
        </SnackbarInitializer>
      </SnackbarProvider>
      ,
    </>
    //     )}
    // </ReactFullscreen>
  );
}

export default App;
